// src/components/Footer.jsx
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Separator } from "../components/ui/separator";
import AnimatedSocialLinks from "../components/AnimatedSocialLinks";

export default function Footer({ canInstall = false, triggerInstallPrompt }) {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 bg-opacity-90 backdrop-blur-lg border-t border-gray-700 mt-12">
      <div className="max-w-7xl mx-auto px-6 py-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center space-x-1.5 mb-4 group">
              <div className="logo-container bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent group-hover:from-blue-500 group-hover:to-purple-500 transition-all flex items-baseline">
                <span className="text-3xl md:text-4xl font-extrabold tracking-tight">SE</span>
                <span className="text-2xl md:text-3xl font-bold tracking-tight">RRA</span>
                <span className="text-3xl md:text-4xl font-extrabold tracking-tight">ND</span>    
              </div>
              <span className="text-lg md:text-xl font-medium text-gray-300 group-hover:text-gray-100 transition-colors">
                | Plug Wa Kazi
              </span>
            </Link>
            <p className="text-sm text-gray-300 mb-6 leading-relaxed">
              Your trusted platform for connecting with local service providers across Kenya.
              From quick errands to major projects, we've got you covered! 🇰🇪
            </p>
            <AnimatedSocialLinks />
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-base font-semibold text-white mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/profile" className="text-gray-300 hover:text-white transition-colors">
                  Profile
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/manage-orders" className="text-gray-300 hover:text-white transition-colors">
                  Manage Orders
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal & Support */}
          <div>
            <h3 className="text-base font-semibold text-white mb-4">Legal & Support</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/terms" className="text-gray-300 hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-300 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* App Install Section */}
        {canInstall && (
          <div className="border-t border-gray-700 pt-8 mt-10">
            <div className="text-center">
              <h3 className="text-base font-semibold text-white mb-3">
                Get the SErraND App! 📱
              </h3>
              <p className="text-sm text-gray-300 mb-4">
                Install our app for the best experience
              </p>
              <Button
                onClick={triggerInstallPrompt}
                variant="default"
                size="lg"
                className="rounded-xl"
              >
                Install Now
              </Button>
            </div>
          </div>
        )}

        {/* Copyright */}
        <Separator className="my-8 opacity-50" />
        <div className="text-center">
          <p className="text-sm text-gray-400">
            © {currentYear} SErraND. All rights reserved. Made with ❤️ in Kenya 🇰🇪
          </p>
          <p className="text-xs text-gray-500 mt-1">
            Connecting communities, one errand at a time.
          </p>
        </div>
      </div>
    </footer>
  );
}
